const PrivacyPolicy = () => {
  return (
    <div style={{ padding: 20, maxWidth: 800, lineHeight: 1.55, color: '#312F2E' }}>
      <h1 style={{ fontSize: 22, marginBottom: 8 }}>Политика конфиденциальности и данные</h1>
      <p style={{ fontSize: 13, color: '#666' }}>
        Последнее обновление: документ отражает требования к прозрачности обработки данных
        и рекомендации для публикации в магазине приложений.
      </p>

      <h2 style={{ fontSize: 17, marginTop: 24 }}>1. Политика конфиденциальности</h2>
      <p>
        Настоящая политика описывает, какие персональные данные могут обрабатываться при
        использовании мобильного приложения «ВМЕСТЕ» (далее — Приложение), в каких целях и
        на каких условиях. Оператор обработки данных определяется вашим работодателем и/или
        организацией, предоставляющей доступ к сервису; уточняющие сведения вы можете
        запросить у администратора программы.
      </p>
      <p>
        Мы стремимся обрабатывать только те данные, которые нужны для работы функций
        Приложения, исполнения договоров и законных интересов пользователей при соблюдении
        баланса с правами субъектов данных.
      </p>

      <h2 style={{ fontSize: 17, marginTop: 24 }}>2. Согласие на сбор и использование данных</h2>
      <p>
        Отдельные действия в Приложении (например, персонализация, участие в программах,
        уведомления) могут опираться на обработку персональных данных в ваших интересах.
        Вы можете выразить согласие на такую обработку в настройках Приложения. Отзыв
        согласия не отменяет законность обработки, выполненной до отзыва, и не препятствует
        обработке, если она требуется по закону или для исполнения договора.
      </p>

      <h2 style={{ fontSize: 17, marginTop: 24 }}>3. Какие данные и зачем (использование и передача)</h2>
      <p>
        В зависимости от используемых функций могут обрабатываться, в частности:
        идентификационные и контактные данные учётной записи (например, телефон, e-mail,
        ФИО — по тем полям, которые вы указываете); технические данные сеанса и устройства,
        необходимые для безопасности и стабильной работы; содержимое форм и материалов,
        которые вы сами направляете через Приложение (заявления, участие в акциях и
        конкурсах и т.п.).
      </p>
      <p>
        Передача третьим лицам осуществляется только в объёме, необходимом для оказания
        услуг (например, подрядчикам по хостингу или поддержке), при наличии правовых
        оснований и договорных гарантий конфиденциальности. Мы не используем данные детей
        для поведенческой рекламы и не продаём персональные данные.
      </p>
      <p>
        Срок хранения определяется целями обработки и требованиями закона; вы можете
        запросить уточнение у оператора программы или отозвать согласие там, где это
        применимо — через настройки в Приложении и обращение в поддержку.
      </p>

      <h2 style={{ fontSize: 17, marginTop: 24 }}>4. Дети</h2>
      <p>
        Приложение не предназначено для самостоятельного использования детьми младше
        возраста, установленного законом, без участия родителей или законных представителей.
        Материалы, связанные с детьми (например, семейные программы), предназначены для
        информирования взрослых пользователей. Мы не собираем сознательно данные детей без
        соответствующего правового основания; если вам стало известно о передаче данных
        ребёнка без согласия родителя, сообщите нам через канал поддержки вашей организации.
      </p>

      <h2 style={{ fontSize: 17, marginTop: 24 }}>
        5. Функции устройства и разрешения (не корпоративный MDM)
      </h2>
      <p>
        Приложение не является решением корпоративного Mobile Device Management (MDM) и не
        управляет устройством вне описанных пользовательских сценариев. Могут запрашиваться
        типовые разрешения платформы, если вы включаете соответствующие функции:
      </p>
      <p>
        • Доступ в интернет — для обмена данными с серверами сервиса.
        <br />
        • Уведомления (push) — для информирования о событиях и сообщениях, если вы
        согласитесь на их получение.
        <br />
        • Камера, фото- и видеогалерея, микрофон — для загрузки изображений/видео
        (например, профиль, конкурсы), при вашем явном действии.
        <br />
        • Геолокация при использовании — если функциональность сервиса запрашивает
        местоположение; система покажет запрос с пояснением.
        <br />
        • Локальное хранилище — для кэша, заметок и настроек на устройстве.
      </p>
      <p>
        Вы можете отозвать отдельные разрешения в настройках операционной системы; часть
        функций Приложения при этом может стать недоступна.
      </p>

      <h2 style={{ fontSize: 17, marginTop: 24 }}>6. Контакты и изменения</h2>
      <p>
        По вопросам персональных данных обращайтесь к администратору программы «ВМЕСТЕ» в
        вашей организации. Мы можем обновлять этот документ; актуальная версия доступна в
        Приложении.
      </p>
    </div>
  );
};

export default PrivacyPolicy;
